import { useMemo } from "react";

export function useFilterSearch<T extends { label: string }>(
  options: T[],
  query: string,
): T[] {
  return useMemo(() => {
    if (!query) return options;
    const lower = query.toLowerCase();
    return options.filter((opt) => opt.label.toLowerCase().includes(lower));
  }, [options, query]);
}
